<template>
    <v-select
      v-model="selectedId"
      @update:model-value="do_change"
      :label="label"
      :placeholder="placeholder"
      :items="selectOptions"
      :density="vuetifyDensity"
      :error="error"
      :error-messages="errorMessages"
      hide-details="auto"
      variant="outlined"
      :clearable="clearable"
    ></v-select>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'lostReasonDetailSelect',
  computed: {
    ...mapGetters('lostReason', ['getLostReasonDetails']),
    reasonDetails() {
      if (this.lostReasonId) {
        return this.getLostReasonDetails(this.lostReasonId);
      }
      return this.getLostReasonDetails();
    },
    selectOptions() {
      const options = this.reasonDetails.map(detail => ({
        value: detail.id,
        title: detail.label
      }));

      if (this.allowAll) {
        options.unshift({ value: 0, title: 'Any Category' });
      }

      return options;
    },
    vuetifyDensity() {
      const densityMap = {
        'default': 'default',
        'small': 'compact',
        'mini': 'comfortable'
      };
      return densityMap[this.size] || 'compact';
    }
  },
  props: {
    lostReasonId: {
      type: Number,
      required: false,
    },
    value: {
      type: [Number, String],
    },
    initialId: {
      type: [Number, Array],
      required: false,
    },
    size: {
      type: String,
      default: () => {
        return 'small';
      },
    },
    placeholder: {
      type: String,
      required: false,
      default: () => {
        return 'Select a detail';
      },
    },
    label: {
      type: String,
      required: false,
      default: () => {
        return 'Lost Reason Detail';
      },
    },
    allowAll: {
      type: Boolean,
      required: false,
      default: () => {
        return false;
      },
    },
    useVuetify: {
      type: Boolean,
      required: false,
      default: true
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false
    },
    multi: {
      type: Boolean,
      required: false,
      default: false
    },
    error: {
      type: Boolean,
    },
    errorMessages: {
      type: Array,
      required: false,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      selectedId: undefined,
    };
  },
  watch: {
    initialId(id) {
      this.selectedId = id;
    },
    value(n) {
      if (!this.multi) {
        this.selectedId = parseInt(n);
      }
    },
  },
  async created() {
    if (this.value != undefined) {
      this.selectedId = parseInt(this.value);
    }
    if (this.initialId) {
      this.selectedId = this.initialId;
    }
  },
  methods: {
    do_change() {
      if (!this.multi) {
        const lsDetail = this.reasonDetails.find(
          (s) => s.id == this.selectedId
        );
        this.$emit('update:lostReasonDetail', lsDetail);
        this.$emit('update:modelValue', lsDetail?.id);
        this.$emit('change', lsDetail?.id);
      } else {
        // Array in this case
        this.$emit('update:lostReasonDetail', this.selectedId);
      }
    },
  },
};
</script>
